window.$ = require('jquery');

$(document).ready(function() {
    var stylesheetUrl = "https://use.typekit.net/bpo0juq.css";

    $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', stylesheetUrl));

});